import {TimelineMax, Quad, Linear} from 'gsap';
const PIXI = require('pixi.js');
const Shortcuts = require('../utils/Shortcuts');
const CustomEase = require('../../../../vendors/CustomEase');
const MousemoveParallax = require('../utils/MousemoveParallax');


const _addView = instance => {
    const cont = new PIXI.Container();
    const TextureCache = PIXI.utils.TextureCache;
    const sizes = require('../../DefaultProjectSize');

    const view = new PIXI.Container();

    const r1cont = new PIXI.Container();
    const r2cont = new PIXI.Container();
    const r3cont = new PIXI.Container();
    const r4cont = new PIXI.Container();
    const r8cont = new PIXI.Container();

    const r1 = new PIXI.Container();
    const r2 = new PIXI.Container();
    const r3 = new PIXI.Container();
    const r4 = new PIXI.Container();
    const r5 = new PIXI.Container();
    const r6 = new PIXI.Container();
    const r7 = new PIXI.Container();
    const r8 = new PIXI.Container();

    let rotate = new PIXI.Container();
    let rotateOppocite = new PIXI.Container();
    let away = new PIXI.Container();
    let img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r1.rotate = rotate;
    r1.rotate.rotateOppocite = rotateOppocite;
    r1.rotate.rotateOppocite.away = away;
    away.addChild(img);
    rotateOppocite.addChild(away);
    rotate.addChild(rotateOppocite);
    r1.addChild(rotate);

    rotate = new PIXI.Container();
    rotateOppocite = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r2.rotate = rotate;
    r2.rotate.rotateOppocite = rotateOppocite;
    r2.rotate.rotateOppocite.away = away;
    away.addChild(img);
    rotate.addChild(away);
    rotate.addChild(rotateOppocite);
    r2.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r3.rotate = rotate;
    r3.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r3.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r4.rotate = rotate;
    r4.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r4.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r5.rotate = rotate;
    r5.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r5.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r6.rotate = rotate;
    r6.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r6.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r7.rotate = rotate;
    r7.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r7.addChild(rotate);

    rotate = new PIXI.Container();
    away = new PIXI.Container();
    img = Shortcuts.getSprite('ravenBase', TextureCache, 'img');
    img.anchor.set(0.5, 0.5);
    img.scale.set(1 / 1.5, 1 / 1.5);
    r8.rotate = rotate;
    r8.rotate.away = away;
    away.addChild(img);
    rotate.addChild(away);
    r8.addChild(rotate);

    r1cont.z = -0.5;
    r2cont.z = 0.5;
    r3cont.z = 0.8;
    r4cont.z = 1.2;
    r8cont.z = 1.5;

    /* r5.alpha = 0;
    r6.alpha = 0;
    r7.alpha = 0;
    r8.alpha = 0;*/

    const overlay = new PIXI.Graphics();
    Shortcuts.rect(overlay, 0, 0, sizes.width, sizes.height, 0x000000);
    overlay.alpha = 0;
    view.alpha = 0;

    r1cont.addChild(r1);
    r2cont.addChild(r2);
    r3cont.addChild(r3);
    r4cont.addChild(r4);
    r8cont.addChild(r8);

    view.addChild(r1cont);
    view.addChild(r2cont);
    view.addChild(r3cont);
    view.addChild(r4cont);
    view.addChild(r5);
    view.addChild(r6);
    view.addChild(r7);
    view.addChild(r8cont);

    cont.addChild(overlay);
    cont.addChild(view);

    instance.cont = cont;
    instance.view = view;
    instance.r1cont = r1cont;
    instance.r2cont = r2cont;
    instance.r3cont = r3cont;
    instance.r4cont = r4cont;
    instance.r8cont = r8cont;
    instance.r1 = r1;
    instance.r2 = r2;
    instance.r3 = r3;
    instance.r4 = r4;
    instance.r5 = r5;
    instance.r6 = r6;
    instance.r7 = r7;
    instance.r8 = r8;
    instance.width = sizes.width;
    instance.height = sizes.height;
    instance.overlay = overlay;

    instance.parallaxLayers = [r1cont, r2cont, r3cont, r4cont, r8cont];
    instance.root.addChild(cont);
}

const _removeView = instance => {
    if (instance.cont.parent)
        instance.cont.parent.removeChild(instance.cont);
}


const _constructTimeline = instance => {
    const tl = new TimelineMax({paused: true});
    const d1 = 2.4 + 0.4, d2 = 6;
    const __getRad = Shortcuts.getRad;

    tl.set([instance.overlay, instance.view], {alpha: 0}, 'in');

    tl.to(instance.overlay, d1 - 0.4, {alpha: 1}, 'in+=' + 0.4);
    tl.to(instance.overlay, 0, {alpha: 0}, 'out');
    tl.to(instance.view, 0, {alpha: 1}, 'out');

    // raven copy
    tl.set(instance.r1.scale, {x: -0.7, y: 0.7}, 'in');
    tl.set(instance.r1, {x: 926.1, y: 836.45, rotation: __getRad(120)}, 'in');
    tl.set(instance.r2.scale, {x: -1, y: 1}, 'in');
    tl.set(instance.r2, {x: 878.4, y: 792.2}, 'in');

    tl.set(instance.r1cont, {z: -0.5}, 'in');
    tl.set(instance.r2cont, {z: 0.5}, 'in');
    tl.set(instance.r1, {alpha: 1}, 'in');
    tl.set([instance.r1.rotate, instance.r2.rotate], {rotation: 0}, 'in');
    tl.set([instance.r1.rotate.rotateOppocite, instance.r2.rotate.rotateOppocite], {rotation: 0}, 'in');
    tl.set([instance.r1.rotate.rotateOppocite.away, instance.r2.rotate.rotateOppocite.away], {x: 125, rotation: __getRad(23)}, 'in');
    tl.set([instance.r1.rotate.rotateOppocite.away.scale, instance.r2.rotate.rotateOppocite.away.scale], {x: 0.58, y: 0.58}, 'in');

    tl.to(instance.r1cont, d2, {z: 1.9}, 'out');
    tl.to(instance.r2cont, d2, {z: 2.4}, 'out');
    tl.to(instance.r1, 0, {alpha: 0}, 'out+=' + d2 * 0.35);
    tl.to([instance.r1.rotate, instance.r2.rotate], d2, {rotation: __getRad(-330), ease: CustomEase.create('custom', 'M0,0,C0.425,0.6,0.725,0.85,1,1')}, 'out'); // 7sec 140frames
    tl.to([instance.r1.rotate.rotateOppocite, instance.r2.rotate.rotateOppocite], d2 * (140 - 48) / 140, {rotation: __getRad(-150), ease: CustomEase.create('custom', 'M0,0,C0.298,0.162,0.762,0.64,1,1')}, 'out+=' + d2 * 48 / 140); // 7sec 140frames
    tl.to([instance.r1.rotate.rotateOppocite.away, instance.r2.rotate.rotateOppocite.away], d2 * 53 / 140, {x: 1056.5, ease: Linear.easeInOut}, 'out'); // 7sec 140frames
    tl.to([instance.r1.rotate.rotateOppocite.away, instance.r2.rotate.rotateOppocite.away], d2 * (140 - 53 - 3) / 140, {x: 1895, ease: Quad.easeOut}, 'out+=' + d2 * 53 / 140); // 7sec 140frames
    tl.to([instance.r1.rotate.rotateOppocite.away.scale, instance.r2.rotate.rotateOppocite.away.scale], d2 * 53 / 140, {x: 1.34, y: 1.34, ease: Linear.easeInOut}, 'out'); // 7sec 140frames
    tl.to([instance.r1.rotate.rotateOppocite.away.scale, instance.r2.rotate.rotateOppocite.away.scale], d2 * (140 - 53 - 3) / 140, {x: 1.83, y: 1.83, ease: Quad.easeOut}, 'out+=' + d2 * 53 / 140); // 7sec 140frames

    // raven
    tl.set(instance.r3cont, {z: 0.8}, 'in');
    tl.set(instance.r4cont, {z: 1.2}, 'in');
    tl.set(instance.r3, {alpha: 1}, 'in');
    tl.set(instance.r3.scale, {x: 1.7, y: 1.7}, 'in');
    tl.set(instance.r3, {x: 942.35, y: 644.2, rotation: __getRad(20.2)}, 'in');
    tl.set(instance.r4.scale, {x: 2.79, y: 2.79}, 'in');
    tl.set(instance.r4, {x: 674.5, y: 912.4, rotation: __getRad(-62)}, 'in');

    tl.set([instance.r3.rotate, instance.r4.rotate], {rotation: 0}, 'in');
    tl.set([instance.r3.rotate.away, instance.r4.rotate.away], {x: 125}, 'in');
    tl.set([instance.r3.rotate.away.scale, instance.r4.rotate.away.scale], {x: 0.58, y: 0.58}, 'in');

    tl.to(instance.r3cont, d2 * 125 / 140, {z: 2.8}, 'out');
    tl.to(instance.r4cont, d2 * 125 / 140, {z: 3.5}, 'out');
    tl.to(instance.r3, 0, {alpha: 0}, 'out+=' + d2 * 0.35);
    tl.to([instance.r3.rotate, instance.r4.rotate], d2 * 125 / 140, {rotation: __getRad(-240), ease: CustomEase.create('custom', 'M0,0,C0.425,0.6,0.725,0.85,1,1')}, 'out'); // 125 frames
    tl.to([instance.r3.rotate.away, instance.r4.rotate.away], d2 * 125 / 140, {x: 1658.4, ease: Linear.easeInOut}, 'out'); // 125frames
    tl.to([instance.r3.rotate.away.scale, instance.r4.rotate.away.scale], d2 * 125 / 140, {x: 1.83, y: 1.83, ease: Linear.easeInOut}, 'out'); // 125frames

    // raven copy 2
    tl.set(instance.r5.scale, {x: 11.19, y: 11.19}, 'in');
    tl.set(instance.r5, {x: 4079.75, y: -984.5, rotation: __getRad(151.3)}, 'in');
    tl.set(instance.r6.scale, {x: 14.91, y: 14.91}, 'in');
    tl.set(instance.r6, {x: 2968.05, y: 3295.35, rotation: __getRad(-119.3)}, 'in');
    tl.set(instance.r7.scale, {x: 21.23, y: 21.23}, 'in');
    tl.set(instance.r7, {x: -1494.1, y: 4305.95, rotation: __getRad(-62)}, 'in');

    tl.set([instance.r5.rotate, instance.r6.rotate, instance.r7.rotate], {rotation: 0}, 'in');
    tl.set([instance.r5.rotate.away, instance.r6.rotate.away, instance.r7.rotate.away], {x: 125}, 'in');
    tl.set([instance.r5.rotate.away.scale, instance.r6.rotate.away.scale, instance.r7.rotate.away.scale], {x: 0.58, y: 0.58}, 'in');
    tl.to([instance.r5.rotate, instance.r6.rotate, instance.r7.rotate], d2 * 125 / 140, {rotation: __getRad(-240), ease: CustomEase.create('custom', 'M0,0,C0.425,0.6,0.725,0.85,1,1')}, 'out'); // 125 frames
    tl.to([instance.r5.rotate.away, instance.r6.rotate.away, instance.r7.rotate.away], d2 * 125 / 140, {x: 178.55, ease: Linear.easeInOut}, 'out'); // 125frames


    // raven copy 3
    tl.set(instance.r8.scale, {x: 4.75, y: 4.75}, 'in');
    tl.set(instance.r8, {x: -1157.95, y: 2912.65, rotation: __getRad(7.3)}, 'in');

    tl.set([instance.r8.rotate], {rotation: 0}, 'in');
    tl.set([instance.r8.rotate.away], {x: 125}, 'in');
    tl.set([instance.r8.rotate.away.scale], {x: 0.58, y: 0.58}, 'in');
    tl.to([instance.r8.rotate], d2, {rotation: __getRad(-161), ease: CustomEase.create('custom', 'M0,0,C0.425,0.6,0.725,0.85,1,1')}, 'out'); // 125 frames
    tl.to([instance.r8.rotate.away], d2, {x: 854.4, ease: Linear.easeInOut}, 'out'); // 125frames
    tl.to([instance.r8.rotate.away.scale], d2, {x: 1.37, y: 1.37, ease: Linear.easeInOut}, 'out'); // 125frames

    instance.timeline = tl;
    return tl;
}


function FlockTransition(app, root) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;
        const instance = {
            app: app,
            root: root
        };
        _addView(instance);

        constructor.instance = instance;
        _created = true;

        MousemoveParallax.startParallax(instance);
        return _constructTimeline(constructor['instance']);
    };

    constructor.destroy = () => {
        if (!_created) return;

        // Delete all the links
        const instance = constructor['instance'];
        Shortcuts.destroyTimeline(instance);
        _removeView(instance);
        MousemoveParallax.stopParallax(instance);
        constructor.instance = null;

        _created = false;
    };

    constructor.startDuration = 2.8;
    constructor.totalDuration = 6.8;

    return constructor;
}


module.exports = FlockTransition;



// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/transitions/FlockTransition.js